/* global BigInt */
// BRDPoSChain network parameters — single source of truth for the frontend.
export const CHAIN = {
    chainId: 3669,
    chainIdHex: '0xe55',
    name: 'BRDPoSChain',
    rpcUrl: 'https://rpc.birr.foundation',
    explorerUrl: 'https://explorer.birr.foundation',
    nativeCurrency: { name: 'Birr', symbol: 'BRC', decimals: 18 },
};

export const shortAddress = (addr) =>
    addr ? `${addr.slice(0, 6)}…${addr.slice(-4)}` : '';

export const txUrl = (hash) => `${CHAIN.explorerUrl}/tx/${hash}`;
export const addressUrl = (addr) => `${CHAIN.explorerUrl}/address/${addr}`;

// Decimal BRC string/number -> hex wei string. Avoids float drift by string math.
export const brcToWeiHex = (amount) => {
    const s = String(amount);
    if (!/^\d+(\.\d+)?$/.test(s)) throw new Error('Invalid BRC amount: ' + s);
    const [whole, frac = ''] = s.split('.');
    const fracPadded = (frac + '0'.repeat(18)).slice(0, 18);
    const wei = BigInt(whole) * (10n ** 18n) + BigInt(fracPadded);
    return '0x' + wei.toString(16);
};

// Hex wei -> decimal BRC string trimmed to `digits` fraction digits.
export const weiHexToBrc = (hex, digits = 4) => {
    const wei = BigInt(hex);
    const whole = wei / (10n ** 18n);
    const frac = (wei % (10n ** 18n)).toString().padStart(18, '0').slice(0, digits);
    const trimmed = frac.replace(/0+$/, '');
    return trimmed ? `${whole}.${trimmed}` : whole.toString();
};
